import { render, staticRenderFns } from "./SmallButtonBar.vue?vue&type=template&id=0020d5b6"
import script from "./SmallButtonBar.vue?vue&type=script&lang=ts"
export * from "./SmallButtonBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports